import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
var Redirect = /*#__PURE__*/function (_Component) {
  function Redirect() {
    _classCallCheck(this, Redirect);
    return _callSuper(this, Redirect, arguments);
  }
  _inherits(Redirect, _Component);
  return _createClass(Redirect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.history.push(this.props.to);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);
}(Component);
export default withRouter(Redirect);